import React, { memo } from "react";
import "./InteractiveGallerySection.css";

const galleryImages = [
  "/images/o.nas/00_54_SPEEHUIS_SpeeArchitecten_3000px-scaled-50e9361b-4221-4e1e-92fb-32f838168543.jpg",
  "/images/o.nas/1 - Black Clichy_France_Accoya®_ECDArchitectes_Grad®.jpg",
  "/images/o.nas/3 - BOOA House_France_Moso® Bamboo X-treme_ Frédéric Godard_Grad®.jpg",
  "/images/o.nas/3 - Private Pool_Portugal_Moso®_Alvaro Jose Pereira_Gra.JPG",
  "/images/o.nas/39c8ce59-82cf-4266-a561-3d6a16ebf3a3.jpg",
  "/images/o.nas/76a19f6f-35e3-4d72-a237-bba280a70aac.jpg",
  "/images/o.nas/92ddb10c-47e4-4895-b0a8-a570084d219e.jpg",
  "/images/o.nas/Buro Ruijs Kootwijkerbroek avond -25.jpg",
  "/images/o.nas/Buro Ruijs Kootwijkerbroek avond -5.jpg",
  "/images/o.nas/dd5bbe2a-f773-4510-932e-5f95fdb365ed.jpg",
  "/images/o.nas/homepage photo.avif",
  "/images/o.nas/Image6.jpg",
  "/images/o.nas/Menu_Inspirations-1.webp",
  "/images/o.nas/R_Hjortshoj - AArhus-121©Rasmus Hjortshøj - COAST.jpg",
];

const MarqueeGallery = memo(() => (
  <div className="marquee-gallery">
    <div className="marquee-track">
      {galleryImages.map((image, index) => (
        <img
          key={`first-${index}`}
          src={image}
          alt={`Projekt ${index + 1}`}
          loading="lazy"
          decoding="async"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ))}
      {galleryImages.map((image, index) => (
        <img
          key={`second-${index}`}
          src={image}
          alt={`Projekt ${index + 1}`}
          loading="lazy"
          decoding="async"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      ))}
    </div>
  </div>
));

MarqueeGallery.displayName = "MarqueeGallery";

export default MarqueeGallery;
